import React, { useCallback, useState } from "react";

import { faAngleDown } from "@fortawesome/pro-solid-svg-icons/faAngleDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "antd/es/dropdown";
import Space from "antd/es/space";
import { useIntl } from "react-intl";

import { MapFilterEntityType } from "@mapmycustomers/shared/types/entity";
import { ModifiedMapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";
import { Button } from "@mapmycustomers/ui";

import getMapFilterTypeForAnalytics from "@app/component/filtering/components/MapFilterButton/utils/getMapFilterTypeForAnalytics";
import { useExtendedAnalytics } from "@app/util/analytic/AnalyticsService";
import useAnalytics from "@app/util/contexts/useAnalytics";

import AvailableEntityTypesMenu from "../../AvailableEntityTypesMenu";

import styles from "./NoFilterState.module.scss";

interface Props {
  entityTypes: MapFilterEntityType[];
  onChange?: (
    callback: (previousFilterModel: ModifiedMapFilterModel) => ModifiedMapFilterModel
  ) => void;
}

const NoFiltersState: React.FC<Props> = ({ entityTypes, onChange }) => {
  const analytics = useExtendedAnalytics("Select Filter type", useAnalytics());
  const intl = useIntl();
  const [dropdownVisible, setDropdownVisibility] = useState(false);

  const handleSelectType = useCallback(
    (entityType) => {
      setDropdownVisibility(false);
      onChange?.((filters) => ({ ...filters, [entityType]: {} }));
      analytics.completed([getMapFilterTypeForAnalytics(entityType)]);
    },
    [analytics, onChange]
  );

  const handleVisibilityChange = useCallback(
    (visible: boolean) => {
      setDropdownVisibility(visible);
      if (visible) {
        analytics.initiated();
      } else {
        analytics.cancelled();
      }
    },
    [analytics]
  );

  return (
    <div className={styles.container}>
      <Dropdown
        onOpenChange={handleVisibilityChange}
        open={dropdownVisible}
        overlay={<AvailableEntityTypesMenu items={entityTypes} onSelect={handleSelectType} />}
        trigger={["click"]}
      >
        <Button rightIcon={<FontAwesomeIcon icon={faAngleDown} />} type="primary">
          <Space>
            {intl.formatMessage({
              id: "map.filters.selectTypeDropdown.noFilters",
              defaultMessage: "Select filter type",
              description:
                "Select filter type dropdown label shown when there are no filters in filter dropdown on Maps page",
            })}
          </Space>
        </Button>
      </Dropdown>
    </div>
  );
};

export default NoFiltersState;
